import TourSearchModel from './TourSearchModel';

export default function tourSearchModel(tourProductsCollection) {
   return new TourSearchModel({ tourProductsCollection });
}